import { useGetLastFinishedChallenge } from "@/hooks/useGetLastFinishedChallenge";
import { useRTLeaderboard } from "@/hooks/useLeaderboard";

// Loads the most recently finished challenge and its leaderboard. Shared by the
// standalone endscreen and the gap-rotation so we only open one RT listener.
export const useFinishedResults = () => {
  const { data: challenge, loading: challengeLoading } =
    useGetLastFinishedChallenge();
  const { data: leaderboard, loading: leaderboardLoading } = useRTLeaderboard(
    challenge?.slug ?? ""
  );

  return {
    challenge,
    leaderboard,
    loading: challengeLoading || leaderboardLoading,
    hasResults: !challengeLoading && !leaderboardLoading && leaderboard.length > 0,
  };
};
